customElements.get("cart-notification") || customElements.define("cart-notification", class extends HTMLElement {
  constructor() {
    super(), this.timeout = +this.getAttribute("data-notification-timeout") || 5e3, 
    this.cartToggleEl = document.getElementById("Cart"), this.mq = matchMedia("(max-width: 1023px)");
  }
  handleClick=e => {
    const t = e.target.closest("[data-close], [data-open-cart]");
    t && (e.preventDefault(), t.hasAttribute("data-open-cart") && !1 === this.cartToggleEl?.checked && this.cartToggleEl.click(), 
    this.hide());
  };
  handleCartChange=e => !e.target.checked && this.hide();
  handleMQChange=e => {
    const t = this.isMobile;
    this.isMobile = e.matches, this.isMobile !== t && (this.isMobile ? this.addTouch() : this.removeTouch());
  };
  addTouch=() => {
    document.addEventListener("touchstart", this.handleTouch, {
      passive: !0
    }), document.addEventListener("click", this.handleTouch);
  };
  removeTouch=() => {
    document.removeEventListener("touchstart", this.handleTouch), document.removeEventListener("click", this.handleTouch);
  };
  handleTouch=e => this.isMobile && !this.contains(e.target) && this.hide();
  hide=() => {
    this.querySelector(":focus")?.blur(), this.setAttribute("aria-hidden", "true"), 
    setTimeout(() => this.remove(), 300);
  };
  handleClose=() => this.hide();
  connectedCallback() {
    setTimeout(() => this.setAttribute("aria-hidden", "false"), 50), this.addEventListener("click", this.handleClick), 
    this.hideTimeout = setTimeout(this.hide, this.timeout), this.cartToggleEl?.addEventListener("change", this.handleCartChange), 
    this.isMobile = this.mq.matches, this.mq.addEventListener("change", this.handleMQChange), 
    this.isMobile && this.addTouch(), addEventListener("cart-notifications:close", this.handleClose);
  }
  disconnectedCallback() {
    clearTimeout(this.hideTimeout), this.removeEventListener("click", this.handleClick), 
    this.cartToggleEl?.removeEventListener("change", this.handleCartChange), this.removeTouch(), 
    this.mq.removeEventListener("change", this.handleMQChange), removeEventListener("cart-notifications:close", this.handleClose);
  }
});